import React from 'react';
import blocation from 'assets/images/location-black.svg';
import bphone from 'assets/images/phone-black.svg';
import bbranch from 'assets/images/branch-black.svg';

export const ListItems = (props) => {
  const items = props.list;
  const styles = props.styles;
  return (
    items &&
    items.map((item, index) => (
      <div className={styles.rightBottom__item} key={index}>
        <h3>
          {item && item.BenfName}
          <span>{item && item.CustomerCode}</span>
        </h3>
        <p>
          <span>
            <img src={blocation} alt="" /> {item && item.BenfCountry}
          </span>
          <span>
            <img src={bphone} alt="" />
            {item.BenfMobileNo && '+'}
            {item && item.BenfMobileNo}
          </span>
        </p>
        <p className={styles.rightBottom__noBorder} style={{ minHeight: '74px' }}>
          <div>
            {item.Service === 'BANK TRANSFER' && (
              <>
                <span style={{ display: 'inline-block' }}>
                  <img src={bbranch} alt="" />
                </span>
                <span style={{ display: 'inline-block' }}>ACCOUNT NUMBER: {item.AccountNo}</span>
                {/* {`${item.BenfAddr1 ? ', ' : ''}`} {item.BenfAddr1} */}
              </>
            )}
            {item?.Service === 'BANK TRANSFER' && item?.BenfBank && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{item?.BenfBank}</span>
              </>
            )}
            {item?.Service === 'BANK TRANSFER' && item?.BenfBranch && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{item?.BenfBranch}</span>
              </>
            )}
            {item?.Service === 'BANK TRANSFER' && item?.BicCode && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{item?.BicCode}</span>
              </>
            )}
          </div>
        </p>
        <h6>
          Service Mode: <span>{item && item.Service}</span>
        </h6>
      </div>
    ))
  );
};
